import React, { useState } from "react";
import emailIcon from "../../assets/dasboard/email-icon.svg";
import { getColorCode } from "../../utils/utility-functions";
import { CreateNewUserModel } from "../model/component";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { LOCALE } from "../../utils/constants";

function SendToFriendButton({
  currentAssessmentAttemptData,
  userGUID,
  userData,
  CreateGuestUserConnect,
  isRomanticCompatibility,
  reportType,
}) {
  const [openSendToFriend, setOpenSendToFriend] = useState(false);
  const [guestUserData, setGuestUserData] = useState([]);
  const [selectedAssessmentAttemptId, setSelectedAssessmentAttemptId] =
    useState("");
  const [selectedAssessmentId, setSelectedAssessmentId] = useState("");
  const handleSendToFriend = (item) => {
    setOpenSendToFriend(true);
    setSelectedAssessmentId(item?.assessmentId);
    setSelectedAssessmentAttemptId(item?.assessmentAttemptId);
  };
  const { t } = useTranslation();
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;
  const currentPersonalityGroup = currentAssessmentAttemptData
    ? currentAssessmentAttemptData?.personality?.role
    : "";

  const personalityColorLight = getColorCode(
    currentPersonalityGroup && currentPersonalityGroup
  ).light;

  return (
    <div>
      <button
        onClick={() => {
          const data = {
            assessmentAttemptId:
              currentAssessmentAttemptData.assessmentAttemptId,
            assessmentId: currentAssessmentAttemptData.assessmentId,
          };
          handleSendToFriend(data);
        }}
        onMouseEnter={(e) =>
          (e.currentTarget.style.backgroundColor = personalityColorLight)
        }
        onMouseLeave={(e) =>
          (e.currentTarget.style.backgroundColor = "transparent")
        }
        className="aspect-square w-max bg-[#d9d9d9] rounded-full flex items-center justify-center"
      >
        <img
          src={emailIcon}
          alt="Email Sharing"
          className="w-[40px] h-auto hover:text-insightful-purple"
        />{" "}
      </button>

      <CreateNewUserModel
        isOpen={openSendToFriend}
        setOpen={setOpenSendToFriend}
        parentId={userGUID}
        CreateGuestUserConnect={CreateGuestUserConnect}
        parentEmail={userData?.email}
        guestUserData={guestUserData}
        assessmentAttemptId={selectedAssessmentAttemptId}
        assessmentId={selectedAssessmentId}
        setGuestUserData={setGuestUserData}
        type={"send_to_friend"}
        t={t}
        currentLocale={currentLocale}
        id={currentAssessmentAttemptData?.id}
        reportType={reportType}
      />
    </div>
  );
}

export default SendToFriendButton;
